import React, {Component} from 'react';
import CreditCard from '@material-ui/icons/CreditCard';
import Bank from '@material-ui/icons/AccountBalance';
import Nav from '@material-ui/core/BottomNavigation';
import NavAction from '@material-ui/core/BottomNavigationAction';
import CreditCardForm from './CreditCardForm';
import AchForm from './AchForm';
import PropTypes from 'prop-types';
import Typography from "../../../../components/Typography";
import {PAYMENT_METHOD_ACH, PAYMENT_METHOD_CREDIT_CARD} from "./helpers";

class PaymentForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      creditCardInfo: {},
      achInfo: {},
      activePaymentMethod: PAYMENT_METHOD_ACH,
    };
    this.props.setPaymentMethod(PAYMENT_METHOD_ACH); // default payment method
  }

  setActivePaymentMethod = (event, value) => {
    this.setState({activePaymentMethod: value});
    this.props.setPaymentMethod(value); // PAYMENT_METHOD_ACH or PAYMENT_METHOD_CREDIT_CARD
  };

  render() {
    const {activePaymentMethod} = this.state;
    return (
      <React.Fragment>
        <Nav
          value={activePaymentMethod}
          onChange={this.setActivePaymentMethod}
          showLabels
        >
          <NavAction label="Bank Account" icon={<Bank/>}/>
          <NavAction label="Credit Card" icon={<CreditCard/>}/>
        </Nav>
        {activePaymentMethod === PAYMENT_METHOD_ACH && <AchForm
          ftniSessionId={this.props.ftniSessionId}
          triggerSubmit={this.props.getAchSubmit}
          onSubmit={this.props.onSubmitAch}
          countryName={this.props.countryName}
        />}
        {activePaymentMethod === PAYMENT_METHOD_CREDIT_CARD && <CreditCardForm
          ftniSessionId={this.props.ftniSessionId}
          triggerSubmit={this.props.getCreditCardSubmit}
          onSubmit={this.props.onSubmitCreditCard}
        />}
        <Typography variant='finePrint' color='secondary.dark' style={{textAlign: 'left', margin: '0.875rem'}}>
          By clicking on "Complete Order", you agree to enroll in our {this.props.type === 'yearly' ? 'annual' : this.props.type} membership subscription plan and to our
          Terms of Service and Privacy Policy. Membership is an auto-recurring subscription charged {this.props.type === 'yearly' ? 'annually' : this.props.type} at the
          then-current rate unless you cancel your subscription before the end of the current subscription period.
          Cancel at any time in Settings (no refunds or credits for partial subscription periods.
        </Typography>
      </React.Fragment>
    );
  }
}

PaymentForm.propTypes = {
  onSubmitCreditCard: PropTypes.func.isRequired,
  onSubmitAch: PropTypes.func.isRequired,
  ftniSessionId: PropTypes.string,
  sessionKey: PropTypes.string,
  getCreditCardSubmit: PropTypes.func.isRequired,
  getAchSubmit: PropTypes.func.isRequired,
  setPaymentMethod: PropTypes.func.isRequired,
  countryName: PropTypes.string,
};


export default PaymentForm;
